import { isEqual } from 'lodash';

export default function isEqualObjValues(obj1, obj2) {
  const sortObjectKeys = obj => {
    return Object.keys(obj)
      .sort()
      .reduce((result, key) => {
        result[key] = obj[key];
        return result;
      }, {});
  };

  const sortedObj1 = sortObjectKeys(obj1 ?? {});
  const sortedObj2 = sortObjectKeys(obj2 ?? {});

  return isEqual(Object.values(sortedObj1), Object.values(sortedObj2));
}
